import { Provider } from '@angular/core';
import { HTTP_INTERCEPTORS } from '@angular/common/http';

import { TokenInterceptor } from './token.interceptor';
import { ExternalLinkService } from '../services';
import { AuthenticationService } from 'src/shared/auth';

export const httpInterceptorProviders: Provider[] = [
    { provide: HTTP_INTERCEPTORS, useClass: TokenInterceptor, deps: [AuthenticationService, ExternalLinkService], multi: true }
];
